export default __webpack_public_path__ + "static/media/imageLogo.2270156b.png";